import { company } from '~/company/Company';
import { useMounted } from '~/hooks/useMounted';
import { cartStore } from '~/stores';
import {
  convertPenceToPounds,
  formatPriceWithCurrency,
} from '~/utils/formaters';

import {
  CART_MEMBERSHIP_NONE,
  type CartMembershipBenefits,
  type CartMoney,
  toCartMembershipBenefits,
} from '../domain/cart';

/**
 * Membership benefits of the current cart, read from the last calculate.
 * Nothing until mount: the calculated orders exist only on the client, so
 * reading them earlier would make the first client render differ from the
 * server markup. Call from an observer component.
 */
export const useCartMembership = (): CartMembershipBenefits => {
  const mounted = useMounted();

  if (!mounted) {
    return CART_MEMBERSHIP_NONE;
  }
  return toCartMembershipBenefits(
    cartStore.deliveriesOrders,
    company.isMembershipsEnabled,
    !company.convertedPricesEnabled,
  );
};

/**
 * Whether a calculate is in flight: the cart blocks still show the previous
 * answer, under a loader. Call from an observer component.
 */
export const isCartRecalculating = (): boolean =>
  cartStore.calculationProcess.isLoading;

/** Formats minor units in the site currency, like the other cart banners. Call during render. */
export const formatCartMoney: CartMoney = (amountMinor) =>
  formatPriceWithCurrency(convertPenceToPounds(amountMinor));
